import { IConfigGeralVendasPut } from "../../../Interfaces/Vendas/ConfigGeral/ConfigGeralInterface";
import {
    ConfigGeralVendasGetService,
    ConfigGeralVendasPutService,
} from "../../../Services/Vendas/ConfigGeral/ConfigGeralService";
import { Controller } from "../../Controller";

export function ConfigGeralVendasGetController() {
    return Controller(ConfigGeralVendasGetService());
}

export function ConfigGeralVendasPutController(
    requestBody: Array<IConfigGeralVendasPut>
) {
    return Controller(ConfigGeralVendasPutService(requestBody));
}
